
import React, { useEffect, useState } from "react";
import Title from '../../../TitleUploaded';
import { UrlApi } from "../../../../services/apirest";
import { Box, Container } from '@mui/material';
import {
    Stepper,
    StepLabel,
    StepButton,
    Step
} from '@mui/material';
import DataProveedores from "../revision/componentes_data/DataProveedores";
import DataImpuestos from "../revision/componentes_data/DataImpuestos";
import DataImputaciones from "../revision/componentes_data/DataImputaciones";
import { handleguardarCambios } from "../revision/funciones";
import ModalArchivos from "../modal_archivos/ModalArchivos";
import moment from "moment";
import Notify from '../../../Notify';
import { validar, esConvenioDirecto, formatearCoeficiente, parseCoeficiente } from "../revision/validaciones";
import { getData } from "../../../../services/library";
import {
    normalizarCorreosPorArea,
    serializeCorreosPorAreaParaApi,
} from "../revision/correosPorAreaUtils";
import { esFlagActivo, idsEmpresasDesdeProveedor, serializeUnidadesNegocioParaApi } from "../revision/unidadesNegocioUtils";
import { getProveedorByCuit } from "../../pago_proveedores/ApiServices";


function EditarGranProveedor(props) {
    const {
        row,
        setopen,
        settabla,
        actualizar,
        soloLectura = false,
        hideTitle = false,
    } = props;
    const steps = ["Datos Generales", "Impuestos", "Imputaciones"];
    const [activeStep, setActiveStep] = useState(0);
    const [imputacionesSeleccionadas, setImputacionesSeleccionadas] = useState([]);
    const [operacionesSeleccionadas, setOperacionesSeleccionadas] = useState([]);
    const [empresasSeleccionadas, setEmpresasSeleccionadas] = useState(
        () => idsEmpresasDesdeProveedor(props.data || row)
    );
    const [provinciasSeleccionadas, setProviniciasSeleccionadas] = useState([]);
    const [documentos, setDocumentos] = useState([]);
    const [datosExenciones, setdatosExcenciones] = useState([]);
    const [regIIBBmanual, setregIIBBmanual] = useState([]); //registros manuales que voy a tomar para modificar
    const [regIIBBmanualOriginal, setregIIBBmanualOriginal] = useState([]);
    const [regIIBBpadron, setregIIBBpadron] = useState([]);
    const [regIIBBpadronOriginal, setregIIBBpadronOriginal] = useState([]);
    const [datosFormulario, setdatosFormulario] = useState({});
    const [correosPorArea, setCorreosPorArea] = useState([]);
    const [operacionOtros, setOperacionOtros] = useState("");
    const [openClose, setopenClose] = useState(false);
    const [provincias, setprovincias] = useState([]);
    const [operacionesProveedor, setoperacionesProveedor] = useState();
    const [operaciones, setOperaciones] = useState([]);
    const [iibbpadrones, setiibbpadrones] = useState([]); //aca guardo lo que viene solo para visualizar
    const [provinciasRevisar, setProvinciasRevisar] = useState([]);
    const [cicloFiscalActual, setCicloFiscalActual] = useState(null);
    const [notify, setNotify] = useState({
        open: false,
        mensaje: "",
        severity: "success",
        color: "",
    });

    const vigenciaDesdeCiclo = (ciclo) => {
        if (!ciclo?.fecha_vto) return { vigencia_date: "", fecha_vigencia_desde: "" };
        const m = moment(ciclo.fecha_vto);
        if (!m.isValid()) return { vigencia_date: "", fecha_vigencia_desde: "" };
        const year = m.format("YYYY");
        return {
            vigencia_date: m.format("YYYY-MM-DD"),
            fecha_vigencia_desde: `${year}-01-01`,
        };
    };

    const getOperacionesProveedor = async () => {
        try {
            const response = await fetch(`${UrlApi}/proveedores/a/operaciones/${row.nro_cuit}`);
            const data = await response.json();
            setoperacionesProveedor(data);
            setOperacionesSeleccionadas(data)
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        getData(`/iibb_proveedores/alliibb/${row.nro_cuit}`, setiibbpadrones);
        getData("/provincias", setProvinciasRevisar)
        getOperacionesProveedor()
        fetch(`${UrlApi}/impuestos/iibb_ciclos_fiscales/actual`)
            .then((res) => res.json())
            .then((data) => {
                const ciclo = Array.isArray(data) ? data[0] : data;
                setCicloFiscalActual(ciclo || null);
            })
            .catch(() => setCicloFiscalActual(null));
    }, []);

    useEffect(() => {
        if (!cicloFiscalActual?.fecha_vto) return;
        const { vigencia_date, fecha_vigencia_desde } = vigenciaDesdeCiclo(cicloFiscalActual);
        if (!vigencia_date) return;
        setregIIBBmanual((prev) => {
            if (!Array.isArray(prev) || prev.length === 0) return prev;
            const alreadyOk = prev.every((reg) => reg.vigencia_date === vigencia_date);
            if (alreadyOk) return prev;
            return prev.map((reg) => ({
                ...reg,
                vigencia_date,
                fecha_vigencia_desde: fecha_vigencia_desde,
            }));
        });
    }, [cicloFiscalActual, regIIBBmanual.length]);

    const getAdjuntos = async () => {
        await fetch(`${UrlApi}/proveedores/x/archivos/${row.nro_cuit}`)
            .then((data) => data.json())
            .then((data) => setDocumentos(data))
    };

    const getEmpresasProveedor = () => {
        setEmpresasSeleccionadas(idsEmpresasDesdeProveedor(props.data || row));
    };

    useEffect(() => {
        if (!row?.nro_cuit) return;
        getAdjuntos();
        getData('/operaciones', setOperaciones);
    }, [row?.nro_cuit]);

    const handleStep = (step) => () => {
        setActiveStep(step);
    };

    const handleClose = () => {
        if (setopen) setopen(false);
        if (settabla) settabla(true);
        if (actualizar) actualizar();
    };

    const ViewFiles = async (archivo, mime) => {
        let response;

        if (mime === "application/pdf") {
            response = await fetch(`${UrlApi}/uploadfiles/uploadspdf/${archivo}`);
        } else {
            response = await fetch(`${UrlApi}/uploadfiles/uploads/${archivo}`);
        }

        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank", "noreferrer");
    };

    const getCorreosPorArea = async (nroCuit) => {
        if (!nroCuit) return;
        try {
            const resp = await fetch(
                `${UrlApi}/proveedores/correos_por_area/${encodeURIComponent(nroCuit)}`
            );
            const data = await resp.json();
            const raw = Array.isArray(data)
                ? data
                : Array.isArray(data?.correos_por_area)
                  ? data.correos_por_area
                  : [];
            aplicarCorreosPorArea(raw);
        } catch (error) {
            console.error("Error al cargar correos por área:", error);
        }
    };

    const aplicarCorreosPorArea = (raw) => {
        const correos = normalizarCorreosPorArea(raw);
        setCorreosPorArea(correos);
        setdatosFormulario((prev) => ({
            ...prev,
            correos_por_area: correos,
        }));
        return correos;
    };

    useEffect(() => {
        const dataInicial = props.data || row;
        console.log("datainicial", dataInicial);


        if (dataInicial) {
            setdatosFormulario({
                //   ...dataInicial,
                nro_cuit: dataInicial.nro_cuit,
                razon_social: dataInicial.razon_social,
                nombre_fantasia: dataInicial.nombre_fantasia,
                direccion: dataInicial.direccion,
                id_pais: dataInicial.id_pais,
                pais: dataInicial.pais,
                id_moneda: dataInicial.id_moneda,
                moneda: dataInicial.moneda,
                sisven_id: dataInicial.sisven_id,
                autogas_id: dataInicial.autogas_id,
                telefono: dataInicial.telefono,
                email: dataInicial.email,
                nombre_contacto: dataInicial.nombre_contacto,
                id_actividadprincipal: dataInicial.id_actividadprincipal,
                id_actividadsecundaria: dataInicial.id_actividadsecundaria,
                id_condicioniva: dataInicial.id_condicioniva,
                condicion: dataInicial.condicion,
                id_convenio: dataInicial.id_convenio,
                convenio: dataInicial.convenio,
                id_banco: dataInicial.id_banco,
                banco: dataInicial.banco,
                cbu: dataInicial.cbu,
                exclusion: dataInicial.exclusion,
                vto_exclusion: dataInicial.vto_exclusion ? moment(dataInicial.vto_exclusion).format("YYYY-MM-DD") : null,
                usuario: localStorage.getItem('user'),
                acepta_echeq: dataInicial.acepta_echeq ?? 0,
                otras_unidades_negocio: dataInicial.otras_unidades_negocio ??
                    (Array.isArray(dataInicial.unidades_negocio) && dataInicial.unidades_negocio.length > 0 ? 1 : 0),
                unidades_negocio: Array.isArray(dataInicial.unidades_negocio)
                    ? dataInicial.unidades_negocio
                    : [],
            });
            setEmpresasSeleccionadas(idsEmpresasDesdeProveedor(dataInicial));
            const correosIniciales = aplicarCorreosPorArea(dataInicial.correos_por_area);
            if (correosIniciales.length === 0 && !soloLectura) {
                getCorreosPorArea(dataInicial.nro_cuit);
            }
        }
    }, [props.data, row]);

    useEffect(() => {
        if (!soloLectura || !row?.nro_cuit) return;

        let cancelled = false;

        const cargarDetalleProveedor = async () => {
            try {
                const detalle = await getProveedorByCuit(row.nro_cuit);
                if (cancelled || !detalle) return;

                const correos = aplicarCorreosPorArea(detalle.correos_por_area);
                if (correos.length === 0) {
                    await getCorreosPorArea(row.nro_cuit);
                }

                setdatosFormulario((prev) => ({
                    ...prev,
                    id_pais: detalle.id_pais ?? prev.id_pais,
                    pais: detalle.pais ?? prev.pais,
                    id_moneda: detalle.id_moneda ?? prev.id_moneda,
                    moneda: detalle.moneda ?? prev.moneda,
                    id_banco: detalle.id_banco ?? prev.id_banco,
                    banco: detalle.banco ?? prev.banco,
                    id_condicioniva: detalle.id_condicioniva ?? prev.id_condicioniva,
                    condicion: detalle.condicion ?? prev.condicion,
                    id_convenio: detalle.id_convenio ?? prev.id_convenio,
                    convenio: detalle.convenio ?? prev.convenio,
                    cbu: detalle.cbu ?? prev.cbu,
                    acepta_echeq: detalle.acepta_echeq ?? prev.acepta_echeq,
                    otras_unidades_negocio: detalle.otras_unidades_negocio ?? prev.otras_unidades_negocio,
                    unidades_negocio: Array.isArray(detalle.unidades_negocio)
                        ? detalle.unidades_negocio
                        : prev.unidades_negocio,
                }));
                if (Array.isArray(detalle.empresasSeleccionadas) || Array.isArray(detalle.empresas)) {
                    setEmpresasSeleccionadas(idsEmpresasDesdeProveedor(detalle));
                }
            } catch (error) {
                if (!cancelled) {
                    console.error("Error al cargar detalle del proveedor:", error);
                }
            }
        };

        cargarDetalleProveedor();

        return () => {
            cancelled = true;
        };
    }, [soloLectura, row?.nro_cuit]);

    const handleAlmacenarDatos = (e) => {
        const { name, value } = e.target;

        setdatosFormulario({
            ...datosFormulario,
            [name]: value,
        });
    };

    const handleGuardarClick = async (e) => {
        // e.preventDefault();

        //filtro las exenciones eliminadas
        const exencionesPadronEliminadas = regIIBBpadronOriginal
            .filter((itemOriginal, index) => {
                const itemIIBB = regIIBBpadron[index];
                return (
                    (itemOriginal.porcentaje_exencion && !itemIIBB.porcentaje_exencion)
                    ||
                    (itemOriginal.vto_exencion && !itemIIBB.vto_exencion)
                );
            })
            .map((item) => ({
                id_provincia: item.id_provincia,
                nro_cuit: String(datosFormulario.nro_cuit).trim()
            }));

        const reqBody = {
            exencionesDePadron:
                regIIBBpadron
                    .filter((registro) =>
                        !!registro.id_provincia &&
                        (!!registro.porcentaje_exencion ||
                            !!registro.vto_exencion
                        ))
                    .map((registro) => {
                        return {
                            nro_cuit: String(datosFormulario.nro_cuit).trim(),
                            id_provincia: registro.id_provincia,
                            porcentaje_exencion: registro.porcentaje_exencion || null,
                            vto_exencion: registro.vto_exencion || null
                        };
                    }) || [],
            exencionesFueraPadron:
                regIIBBmanual.map((registro) => {
                    const coeficiente = parseCoeficiente(registro.coeficiente ?? registro.retencion);
                    const cicloVigencia = vigenciaDesdeCiclo(cicloFiscalActual);
                    const vigencia_date =
                        cicloVigencia.vigencia_date ||
                        registro.vigencia_date ||
                        (registro.fecha_vigencia_desde
                            ? String(registro.fecha_vigencia_desde).slice(0, 4)
                            : null);
                    return {
                        nro_cuit: String(datosFormulario.nro_cuit).trim(),
                        id_provincia: registro.id_provincia,
                        porcentaje_exencion: registro.porcentaje_exencion ?? null,
                        vto_exencion: registro.vto_exencion ?? null,
                        coeficiente: coeficiente,
                        vigencia_date: vigencia_date
                    };
                }) || [],
            regIIBBmanual:
                regIIBBmanual
                    .filter((registro) =>
                        !!registro.id_provincia ||
                        !!registro.coeficiente ||
                        !!registro.retencion ||
                        !!registro.porcentaje_exencion ||
                        !!registro.vto_exencion
                    )
                    .map((registro) => {
                        const coeficiente = parseCoeficiente(registro.coeficiente ?? registro.retencion);
                        const cicloVigencia = vigenciaDesdeCiclo(cicloFiscalActual);
                        const vigencia_date =
                            cicloVigencia.vigencia_date ||
                            registro.vigencia_date ||
                            (registro.fecha_vigencia_desde ? String(registro.fecha_vigencia_desde).slice(0, 4) : "");
                        return {
                            nro_cuit: String(datosFormulario.nro_cuit).trim(),
                            retencion: coeficiente,
                            coeficiente: coeficiente,
                            id_provincia: registro.id_provincia,
                            vigencia_date: vigencia_date,
                            fecha_vigencia_desde:
                                cicloVigencia.fecha_vigencia_desde ||
                                registro.fecha_vigencia_desde ||
                                (vigencia_date ? `${String(vigencia_date).slice(0, 4)}-01-01` : ""),
                        }
                    }) || [],
            eliminados:
                (regIIBBmanualOriginal &&
                    regIIBBmanualOriginal.filter(
                        (regOriginal) =>
                            !regIIBBmanual.find(
                                (reg) =>
                                    String(reg.nro_cuit).trim() ===
                                    String(regOriginal.nro_cuit).trim()
                                    &&
                                    reg.id_provincia === regOriginal.id_provincia
                            )
                    )) || [],
            exencionesPadronEliminadas: exencionesPadronEliminadas
        };

        const errores = validar(
            regIIBBmanual,
            reqBody.exencionesDePadron,
            reqBody.exencionesFueraPadron,
            {
                regIIBBpadron,
                id_convenio: datosFormulario.id_convenio ?? row.id_convenio,
                cicloFiscalActual,
            }
        );

        if (errores.length > 0) {
            setNotify({
                open: true,
                severity: "error",
                color: "#FADBD8",
                mensaje: errores.join(" | "),
            });
            return;
        }

        const otrasUnidades = esFlagActivo(datosFormulario.otras_unidades_negocio);
        const resultado = await handleguardarCambios({
            datosFormulario: {
                ...datosFormulario,
                correos_por_area: serializeCorreosPorAreaParaApi(correosPorArea),
                acepta_echeq: esFlagActivo(datosFormulario.acepta_echeq) ? 1 : 0,
                otras_unidades_negocio: otrasUnidades ? 1 : 0,
                unidades_negocio: otrasUnidades
                    ? serializeUnidadesNegocioParaApi(datosFormulario.unidades_negocio)
                    : [],
            },
            imputacionesSeleccionadas,
            empresasSeleccionadas: (empresasSeleccionadas || [])
                .map(Number)
                .filter((id) => Number.isFinite(id)),
            operacionesSeleccionadas,
            accion: 2,
            reqBody,
            setNotify
        });
        if (resultado?.ok && typeof actualizar === "function") {
            actualizar();
        }
    };

    //PARA EL MODAL DONDE VOY A MANEJAR LOS ARCHIVOS
    const [modalConfig, setModalConfig] = useState({ open: false, tipoId: null, label: "", provincia: null });

    // Función para abrir el modal configurado
    const abrirGestorAdjunto = (id, nombre, idProvincia = null) => {

        const idLimpio = Number(id);

        setModalConfig({
            open: true,
            tipoId: idLimpio,
            provincia: idLimpio === 6 ? idProvincia : null,
            label: nombre || "Documento",
            nro_cuit: datosFormulario.nro_cuit
        });
    };

    // Buscamos si existe un archivo para el tipo abierto actualmente
    // const archivoActual = documentos && documentos.find(doc => Number(doc.id_tipoadjunto) === Number(modalConfig.tipoId));
    const archivoActual = documentos && documentos.find(a => {
        // Caso especial: tipo 6 → también matchea provincia
        if (modalConfig.tipoId === 6) {
            return (
                a.tipoId === 6 &&
                a.provincia === modalConfig.provincia
            );
        }

        // Caso normal
        return a.tipoId === modalConfig.tipoId;
    });

    //esta funcion guarda los datos originales e inicia el nuevo objeto que voy a poder modificar para comparar antes de guardar 
    const iniciardatosIIBBManual = (datos) => {
        setregIIBBmanual(datos);
        setregIIBBmanualOriginal(datos);
    };

    const iniciarIIBBPadrones = (data) => {
        const deepCopy = JSON.parse(JSON.stringify(data));
        setregIIBBpadron(data);
        setregIIBBpadronOriginal(deepCopy);
    };

    //obtengo los datos manuales 
    const getIIBBManual = () => {
        fetch(`${UrlApi}/iibb_proveedores/nro_cuit/${row.nro_cuit}`)
            .then((data) => data.json())
                // .then((data) => console.log("data",data))
            .then((data) => {
                const cicloVigencia = vigenciaDesdeCiclo(cicloFiscalActual);
                const esDirecto = esConvenioDirecto(datosFormulario.id_convenio ?? row.id_convenio);
                data.length > 0 ?
                    iniciardatosIIBBManual(
                        data.map((reg) => {
                            const coef = esDirecto
                                ? "1,0000"
                                : formatearCoeficiente(reg.coeficiente ?? reg.retencion, { esDirecto });
                            return {
                                ...reg,
                                coeficiente: coef,
                                retencion: coef,
                                vigencia_date: cicloVigencia.vigencia_date || reg.vigencia_date || "",
                                fecha_vigencia_desde:
                                    cicloVigencia.fecha_vigencia_desde ||
                                    reg.fecha_vigencia_desde ||
                                    "",
                            };
                        })
                    )
                    :
                    setregIIBBmanual([
                        {
                            nro_cuit: row.nro_cuit,
                            retencion: esDirecto ? "1,0000" : "",
                            coeficiente: esDirecto ? "1,0000" : "",
                            vigencia_date: cicloVigencia.vigencia_date || "",
                            fecha_vigencia_desde: cicloVigencia.fecha_vigencia_desde || "",
                            id_provincia: ""
                        }
                    ])
            })
    };

    //traigo los datos del proveedor que viene del padron--
    const getRegPadrones = () => {
        fetch(`${UrlApi}/padron/proveedores/${row.nro_cuit}`)
            .then(data => data.json())
            // .then(data => console.log("data",data))
            .then(data => iniciarIIBBPadrones(data))
    };

    const getProvincias = () => {
        fetch(`${UrlApi}/provincias/iibbmanual`)
            .then(data => data.json())
            .then(data => setprovincias(data))
    };

    useEffect(() => {
        getIIBBManual();
        getRegPadrones();
        getProvincias()
        getEmpresasProveedor()
    }, [row.nro_cuit]);


    //ACA VOYT A GUARDAR TODAS LAS PROPIEDADES QUE LE PASO A LOS OTROS COMPONENTES
    const propiedades = {
        datos: datosFormulario,
        setDatos: setdatosFormulario,
        documentos: documentos,
        handleAlmacenarDatos: handleAlmacenarDatos,
        openClose: openClose,
        setopenClose: setopenClose,
        editar: soloLectura ? 0 : 1,
        ViewFiles: soloLectura ? ViewFiles : undefined,
        soloDetalle: soloLectura,
        abrirGestorAdjunto: abrirGestorAdjunto,
        archivoActual: archivoActual,
        operacionesSeleccionadas: operacionesSeleccionadas,
        setOperacionesSeleccionadas: setOperacionesSeleccionadas,
        operacionOtros: operacionOtros,
        setOperacionOtros: setOperacionOtros,
        step: activeStep,
        imputacionesSeleccionadas: imputacionesSeleccionadas,
        setImputacionesSeleccionadas: setImputacionesSeleccionadas,
        notify: notify,
        data: row,
        empresasSeleccionadas: empresasSeleccionadas,
        setEmpresasSeleccionadas: setEmpresasSeleccionadas,
        handleGuardarClick: handleGuardarClick,
        datosExenciones: datosExenciones,
        setdatosExcenciones: setdatosExcenciones,
        provinciasSeleccionadas: provinciasSeleccionadas,
        setProviniciasSeleccionadas: setProviniciasSeleccionadas,
        regIIBBmanual: regIIBBmanual,
        setregIIBBmanual: setregIIBBmanual,
        regIIBBpadron: regIIBBpadron,
        setregIIBBpadron: setregIIBBpadron,
        regIIBBmanualOriginal: regIIBBmanualOriginal,
        setregIIBBmanualOriginal: setregIIBBmanualOriginal,
        iniciardatosIIBBManual: iniciardatosIIBBManual,
        iniciarIIBBPadrones: iniciarIIBBPadrones,
        provincias: provincias,
        operacionesProveedor: operacionesProveedor,
        setoperacionesProveedor: setoperacionesProveedor,
        operaciones: operaciones,
        setOperaciones: setOperaciones,
        iibbpadrones:iibbpadrones, 
        setiibbpadrones:setiibbpadrones,
        provinciasRevisar:provinciasRevisar, 
        setProvinciasRevisar:setProvinciasRevisar,
        correosPorArea,
        setCorreosPorArea,
        cicloFiscalActual,
    };

    if (!row?.nro_cuit) {
        return null;
    }

    return (
        <div>
            {!hideTitle ? (
                <Title
                    title={`${soloLectura ? "Detalle" : "Editar"} proveedor ${row.razon_social}`}
                    pt={2}
                    handleClose={handleClose}
                />
            ) : null}
            <Box sx={{ width: '100%', mt: 3 }}>
                <Stepper activeStep={activeStep} nonLinear sx={{ mt: -2, mb: 2 }}>
                    {steps.map((label, index) => (
                        <Step key={label}>
                            <StepButton onClick={handleStep(index)}>
                                <StepLabel
                                    StepIconProps={{
                                        sx: {
                                            color: index === activeStep ? "#1976d2" : "grey.400",
                                            fontSize: "2rem",
                                        },
                                    }}
                                    sx={{
                                        "& .MuiStepLabel-label": {
                                            fontWeight: index === activeStep ? "bold" : "normal",
                                            color: index === activeStep ? "#1976d2" : "text.secondary",
                                        },
                                    }}
                                >
                                    {label}
                                </StepLabel>
                            </StepButton>
                        </Step>
                    ))}
                </Stepper>
            </Box>
            {activeStep === 0 && <DataProveedores {...propiedades} />}

            {activeStep === 1 && <DataImpuestos {...propiedades} />}

            {activeStep === 2 && <DataImputaciones {...propiedades} />}

            {modalConfig.open && (
                <ModalArchivos
                    modalConfig={modalConfig} // Enviamos el objeto completo
                    setModalConfig={setModalConfig} // Enviamos la función para cerrar
                    documentos={documentos} // Los archivos que ya cargaste
                    nro_cuit={row.nro_cuit}
                    getAdjuntos={getAdjuntos}
                />
            )}

            {notify && notify.open ? (
                <Notify
                    mensaje={notify.mensaje}
                    open={notify.open}
                    color={notify.color}
                    handleClose={() => {
                        if (notify.severity === "error") {
                            setNotify((prev) => ({ ...prev, open: false }));
                            return;
                        }
                        handleClose();
                    }}
                    severity={notify.severity}
                    duracion={notify.severity === "error" ? 6000 : 1000}
                />
            ) : null}
        </div>
    )
}

export default EditarGranProveedor;